import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";

import SearchBlockRHF from "../../../components/GeneralComponents/searchBlockRHF/SearchBlockRHF";
import ToolBlock from "../../../components/AdministrativeProcedures/commonComponents/ToolBlock/ToolBlock";
import TableComponent from "../../../components/GeneralComponents/SearchTable/tableComponent";

import { RECORD_TRAINED_USER_LOGBOOK_COLUMNS } from "../../../components/GeneralComponents/SearchTable/TablesColumns";

import {
  getDataRecordTrainedUsersLogbookBySearchParams,
  getDataRecordTrainedUsersLogbookPagination,
} from "../../../redux/recordTrainedUsersReducer/actionsRecordTrainedUsers";

import {
  options,
  setOptionsProgramId,
} from "../../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";

import styles from "./recordTrainedUsersLogbook.module.css";

export default function RecordTrainedUsersLogbook() {
  const dispatch = useDispatch();

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedPage, setSelectedPage] = useState(0);
  const [searchParams, setSearchParams] = useState({
    surname: "",
    name: "",
    midname: "",
    birthDate: "",
    trainingOrgsId: 0,
    trainingProgId: 0,
    trainingDocumentsDateStart: "",
    trainingDocumentsDateEnd: "",
  });

  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });
  const dataRecordLogbook = useSelector((state) => {
    const { recordTrainedUsersReducer } = state;
    return recordTrainedUsersReducer.dataRecordLogbook;
  });
  const dataPaginationRecordLogbook = useSelector((state) => {
    const { recordTrainedUsersReducer } = state;
    return recordTrainedUsersReducer.dataPaginationRecordLogbook;
  });
  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });

  const printAccess = useChapterActionIdMatch(
    sortedMenuNames?.RECORD_TRAINED_USER_LOGBOOK?.magazinePrinting
      ?.chapterActionId,
  );

  const handleChange = (e) => {
    if (e.target) {
      setSearchParams({
        ...searchParams,
        [e.target.dataset.id]: e.target.value,
      });
    } else {
      setSearchParams({ ...searchParams, [e.key]: e.value });
    }
  };

  const handleSearch = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    dispatch(getDataRecordTrainedUsersLogbookBySearchParams(searchParams));
    dispatch(getDataRecordTrainedUsersLogbookPagination(searchParams, 0));
  };

  const handleClear = () => {
    setSelectedPage(0);
    setSelectedRowData(null);

    setSearchParams(
      structuredClone({
        surname: "",
        name: "",
        midname: "",
        birthDate: "",
        trainingOrgsId: 0,
        trainingProgId: 0,
        trainingDocumentsDateStart: "",
        trainingDocumentsDateEnd: "",
      }),
    );
    dispatch(
      getDataRecordTrainedUsersLogbookPagination(
        {
          surname: "",
          name: "",
          midname: "",
          birthDate: "",
          trainingOrgsId: 0,
          trainingProgId: 0,
          trainingDocumentsDateStart: "",
          trainingDocumentsDateEnd: "",
        },
        0,
      ),
    );
    dispatch(
      getDataRecordTrainedUsersLogbookBySearchParams({
        surname: "",
        name: "",
        midname: "",
        birthDate: "",
        trainingOrgsId: 0,
        trainingProgId: 0,
        trainingDocumentsDateStart: "",
        trainingDocumentsDateEnd: "",
      }),
    );
  };

  const handleRowSelect = (rowData) => {
    setSelectedRowData(rowData);
  };

  const fetchPageData = (pageIndex) => {
    setSelectedPage(pageIndex);
  };

  useMemo(() => {
    setSelectedRowData(null);
    dispatch(
      getDataRecordTrainedUsersLogbookPagination(searchParams, selectedPage),
    );
  }, [selectedPage]);

  useEffect(() => {
    if (dictionaryReducer.trainingProgramLibrary.length > 0) {
      const validLib = dictionaryReducer.trainingProgramLibrary.map((item) => {
        return {
          value: item.id,
          label: item.sign,
          key: "trainingProgId",
        };
      });
      setOptionsProgramId(
        validLib,
        options.inputsRecordTrainedUsersLogbook.key,
        "trainingProgId",
      );
    }
  }, [dictionaryReducer]);

  useEffect(() => {
    if (dictionaryReducer.trainingProgramLibrary.length > 0) {
      const validLib = dictionaryReducer.trainingProgramLibrary.map((item) => {
        return {
          value: item.id,
          label: item.sign,
          key: "trainingProgId",
        };
      });
      setOptionsProgramId(
        validLib,
        options.inputsRecordTrainedUsersLogbook.key,
        "trainingProgId",
      );
    }
  }, []);

  useEffect(() => {
    dispatch(getDataRecordTrainedUsersLogbookBySearchParams(searchParams));
    fetchPageData(0);
  }, []);

  return (
    <div className={styles["content-container"]}>
      <SearchBlockRHF
        options={options.inputsRecordTrainedUsersLogbook}
        handleChange={handleChange}
        handleSearch={handleSearch}
        handleClear={handleClear}
        searchParams={searchParams}
        externalStyles={styles}
      />
      <ToolBlock
        data={dataRecordLogbook}
        searchParams={searchParams}
        printAccess={printAccess}
      />
      <TableComponent
        fetchData={fetchPageData}
        onRowSelect={handleRowSelect}
        columns={RECORD_TRAINED_USER_LOGBOOK_COLUMNS}
        data={dataPaginationRecordLogbook.content || []}
        totalPages={dataPaginationRecordLogbook.totalPages || 0}
        totalElements={dataPaginationRecordLogbook.totalElements || 0}
        selectedPage={selectedPage}
      />
    </div>
  );
}
